export default "dist/images/rabit1.png"